import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';

interface Props {
  label: string;
  value: string;
}

const Item: React.FC<Props> = ({ label, value }) => {
  return (
    <View className="flex-row items-center justify-between mb-4">
      <Text className="text-gray-400 text-sm mr-4">{label}</Text>
      <Text className="text-gray-700 font-medium text-right flex-1">
        {value}
      </Text>
    </View>
  );
};

export default Item;
